import { motion } from "framer-motion";

export const HeroTitle = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center max-w-4xl mx-auto space-y-6"
    >
      <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold leading-tight">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-secondary to-accent">
        Join 1000+ Kids Building Strength, Confidence, and Fun at India’s 1st Gymnastics Center 
        </span>
      </h1>
      
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.4 }}
        className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto"
      >
    Our expert led gymnastics programs build strength, boost confidence, enhance social skills, and inspire creativity all while keeping them active and happy!

      </motion.p>
    </motion.div>
  );
};